//************************************************************************ /
// SHARE STORY CTA CARD
// Used on event detail.tsx view. If there are stories, this is the first
// card that is displayed, encouraging users to upload more stories.
//************************************************************************ /

import React from "react";
import {
  Card,
  Button,
  Group,
  Typography,
} from "@dreambigger/design-system/src/components";
import { Event as EventType } from "@dreambigger/shared/src/types";

const { Title, Text } = Typography;

type ShareStoryCtaCardProps = {
  event: EventType;
};

const handleClick = () => {
  window.location.pathname = window.location.pathname.replace(
    "detail",
    "share"
  );
};

// Event is currently unused, but will eventually be used for link url.
const ShareStoryCtaCard = ({ event }: ShareStoryCtaCardProps) => {
  return (
    <Card
      style={{
        backgroundColor: "black",
      }}
      className={`lift pointer`}
      onClick={handleClick}
    >
      <Group className="items-center tc">
        {/* Call To Action Text */}
        <Title level={4} className="white lh-3 mb-3">
          Share Your Experience!
        </Title>
        <Text className="white lh-2 mb-5">
          Join with others by sharing a photo or story from the event.
        </Text>
        {/* Button Link */}
        <Button
          type="primary"
          className={` lightenPrimaryBkd bg-primary b-primary ttu f-2 mb-3`}
        >
          Share a Photo
        </Button>
        <Text className="mb-0 white hlight-primary fwb ttu f-2 pointer">
          Or Comment
        </Text>
      </Group>
    </Card>
  );
};

export default ShareStoryCtaCard;
